import { createContext, type ReactNode, useContext } from "react";

import type { ProgrammeHubServices } from "./types.js";

const ProgrammeHubContext = createContext<ProgrammeHubServices | null>(null);

export function ProgrammeHubProvider({
  value,
  children,
}: {
  value: ProgrammeHubServices;
  children: ReactNode;
}) {
  return <ProgrammeHubContext.Provider value={value}>{children}</ProgrammeHubContext.Provider>;
}

/**
 * Read the hub-injected `ProgrammeHubServices` port (ADR-0101 Phase 5a).
 * Every Programme component that needs a hub-owned domain (auth, tenants,
 * default engagement) calls this instead of importing `packages/web/src/**`
 * directly.
 */
export function useProgrammeHub(): ProgrammeHubServices {
  const ctx = useContext(ProgrammeHubContext);
  if (!ctx) {
    throw new Error("useProgrammeHub must be used within <ProgrammeHubProvider>");
  }
  return ctx;
}
